import { post, knowledgeApi } from '../../supportApi';
import { getStoredActiveProfileMode } from '../../../profileIdentity/activeProfileMode';

export function buildDiscussionCommentsApi(discussionSlug) {
  const d = discussionSlug;
  return {
    commentsList: (_s, opts) => post('/knowledge/comments/list', { discussionSlug: d, ...opts }),
    commentsSubtree: (_s, commentId) =>
      post('/knowledge/comments/subtree', { discussionSlug: d, commentId: String(commentId) }),
    commentsAdd: (_s, body, parentCommentId, flags = {}) =>
      post('/knowledge/comments/add', {
        discussionSlug: d,
        body,
        parentCommentId,
        spoiler: Boolean(flags.spoiler),
        ageRestricted: Boolean(flags.ageRestricted),
        sensitivity: Boolean(flags.sensitivity),
        profileMode: flags.profileMode || getStoredActiveProfileMode(),
      }),
    commentsUpdate: (_s, commentId, body, flags = {}) =>
      post('/knowledge/comments/update', {
        discussionSlug: d,
        commentId,
        body,
        spoiler: Boolean(flags.spoiler),
        ageRestricted: Boolean(flags.ageRestricted),
        sensitivity: Boolean(flags.sensitivity),
      }),
    commentsDelete: (_s, commentId) => post('/knowledge/comments/delete', { discussionSlug: d, commentId }),
    commentReactionToggle: (_s, commentId, emoji) =>
      post('/knowledge/comments/reactions/toggle', { discussionSlug: d, commentId, emoji }),
    commentsVote: (_s, commentId, vote) => post('/knowledge/comments/vote', { discussionSlug: d, commentId, vote }),
    commentDisable: (_s, commentId, reason) => knowledgeApi.discussionsCommentDisable(d, commentId, reason),
  };
}

export function buildCoverCommentsApi(coverUserId) {
  const userId = String(coverUserId || '').trim();
  return {
    commentsList: (_s, opts) => post('/knowledge/comments/list', { coverUserId: userId, ...opts }),
    commentsSubtree: (_s, commentId) =>
      post('/knowledge/comments/subtree', { coverUserId: userId, commentId: String(commentId) }),
    commentsAdd: (_s, body, parentCommentId, flags = {}) =>
      post('/knowledge/comments/add', {
        coverUserId: userId,
        body,
        parentCommentId,
        spoiler: Boolean(flags.spoiler),
        ageRestricted: Boolean(flags.ageRestricted),
        sensitivity: Boolean(flags.sensitivity),
        profileMode: flags.profileMode || getStoredActiveProfileMode(),
      }),
    commentsUpdate: (_s, commentId, body, flags = {}) =>
      post('/knowledge/comments/update', {
        coverUserId: userId,
        commentId,
        body,
        spoiler: Boolean(flags.spoiler),
        ageRestricted: Boolean(flags.ageRestricted),
        sensitivity: Boolean(flags.sensitivity),
      }),
    commentsDelete: (_s, commentId) => post('/knowledge/comments/delete', { coverUserId: userId, commentId }),
    commentReactionToggle: (_s, commentId, emoji) =>
      post('/knowledge/comments/reactions/toggle', { coverUserId: userId, commentId, emoji }),
    commentsVote: (_s, commentId, vote) => post('/knowledge/comments/vote', { coverUserId: userId, commentId, vote }),
    commentDisable: () => Promise.reject(new Error('Moderation for cover comments is not supported yet')),
  };
}
